<template>
  <div class="ml-5 mr-5">
    <v-row justify="center">
      <v-col class="text-right">
        Membership No
      </v-col>
      <v-col>{{ userRecord.userNo }}</v-col>
    </v-row>
    <v-row justify="center">
      <v-col class="text-right">
        Name
      </v-col>
      <v-col>{{ userRecord.fullName }}</v-col>
    </v-row>
    <v-row justify="center">
      <v-col class="text-right">
        Gender
      </v-col>
      <v-col>{{ gender }}</v-col>
    </v-row>

    <v-row
      v-if="coachEnable"
      justify="center"
    >
      <v-col class="text-right">
        Position
      </v-col>
      <v-col>{{ userRecord.coachInfo.position }}</v-col>
    </v-row>
    <v-row
      v-if="coachEnable"
      justify="center"
    >
      <v-col class="text-right">
        Join date
      </v-col>
      <v-col>{{ moment(userRecord.coachInfo.joinDate).format('YYYY-MM-DD') }}</v-col>
    </v-row>
    <v-row
      v-if="!coachEnable"
      justify="center"
    >
      <v-col class="text-right">
        Latest Order Expiry Date
      </v-col>
      <v-col>{{ moment(joinDate).format('YYYY-MM-DD') }}</v-col>
    </v-row>
  </div>
</template>
<script setup>
import { ref, computed, toRefs, onMounted } from 'vue'
import * as moment from 'moment'
import { findFarExpiryDate } from '@/api/salesOrder'

const joinDate = ref('')

const props = defineProps({
  userRecord: {
    type: Object,
    default() {
      return {
        fullName: 'Paul Chan',
        gender: 'M',
        userNo: 'TST202300012',
      }
    },
  },
  coachEnable: {
    type: Boolean,
    default: false,
  },
})
const { userRecord, coachEnable } = toRefs(props)
const gender = computed(() => {
  if (userRecord.value.gender && userRecord.value.gender.toUpperCase() === 'F') { return 'Female' }

  // console.log('userRecord.gender',userRecord.value.gender)
  return 'Male'
})

onMounted(() => {
  findFarExpiryDate({ page: 0, limit: 0, OrderBy: 'ExpiryDate', OrderDesc: true })
    .then(response => {
      joinDate.value = response.data.record.expiryDate
    })
    .catch(err => {

    })
})

</script>
